import { MealType } from "./../enums";

export const mealSortOrder: Record<MealType, number> = {
  [MealType.MenuOfTheDay]: 1,
  [MealType.Appetizers]: 2,
  [MealType.MainCourses]: 3,
  [MealType.SideCourses]: 4,
  [MealType.Desserts]: 5,
  [MealType.Drinks]: 6,
  [MealType.Other]: 7,
  [MealType.Unknown]: 8,
};
